import { render, staticRenderFns } from "./DsnColorPanel.vue?vue&type=template&id=198678d2&"
import script from "./DsnColorPanel.vue?vue&type=script&lang=js&"
export * from "./DsnColorPanel.vue?vue&type=script&lang=js&"
import style0 from "./DsnColorPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports